import moment from "moment";
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import AppLayout from "../components/AppLayout";
import {
  getBusiness,
  renewBusiness,
  restrictBusiness,
} from "../logic/business/action";
import { getCoupon, getPlan } from "../logic/plans/action";
import Header from "../components/header";
import { deleteData } from "../utils/serverHelper";
import { DELETE_BUSINESS } from "../utils/urls";
import { toast } from "react-toastify";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Switch } from "@mui/material";
import { changeBusinessPlan, changeBusinessPrice } from "../logic/business/reducer";
import { MdDelete, MdRefresh } from "react-icons/md";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const BusinessList = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state?.business);
  const selectorPlan = useSelector((state) => state?.plans);
  const [discount, setdiscount] = useState(0);
  const [deleteBusiness, setDeleteBusiness] = useState(0);
  const [open, setopen] = useState(false);

  
  const [editdata, seteditdata] = useState({
    id:0,
    plan:0,
    month:0,
  });
  useEffect(() => {
    getPlan(dispatch);
    getCoupon(dispatch);
    getBusiness(dispatch);
  }, []);

  const renewLocal = async (id, plan,month) => {
    seteditdata({id,plan,month});
    setopen(true);
  };
  console.log("my", selector?.data[0]?.expired_plan);

  const deleteBusinessFunc = async() => {
    try {
      if(deleteBusiness !== 0){
        await deleteData(DELETE_BUSINESS(deleteBusiness));
        await getBusiness(dispatch);
        setDeleteBusiness(0);
      }
    } catch (error) {
      console.log(error);
      toast.error( error.response?.data?.error?.message || 'Something went wrong for deleting business' );
      setDeleteBusiness(0);
    }
  }

  return (
    <AppLayout>
      <div className="w-full h-full flex flex-col items-start gap-4">
       <Header title={'Business List'} actions={<>
       <Button 
        onClick={()=>{
    getBusiness(dispatch);
        }}
        variant="outlined" size="small" startIcon={<MdRefresh/>}>refresh</Button>
       </>}/> 


        <Dialog open={open}>
          <DialogTitle>Do you want to Upgrade/DownGrade users plan ??</DialogTitle>
          <DialogContent>
                <select name="coupon" id="coupon"
                value={discount}
                onChange={(ev)=>setdiscount(parseInt(ev.target.value))}
                >
                  <option value={0} disabled>Select Coupon</option>
                  {
                    selectorPlan.coupons.filter(ev=>ev.active === 1).map(
                      (co,i)=><option value={co.id}>{co.coupen_code}-{co.price} {co.ispercent===0?'Rs':'%'}</option>
                    )
                  }
            </select>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{
              setopen(false);
              seteditdata({
                id:0,
                plan:0,
                month:0,
              });
              setdiscount(0);
            
            }}>cancel</Button>
            <Button variant="contained" color="info" onClick={()=>{

renewBusiness(dispatch,editdata.id,editdata.plan,editdata.month,discount);
setopen(false);
seteditdata({
  id:0,
  plan:0,
  month:0,
});
setdiscount(0);
            }}>save</Button>
          </DialogActions>
        </Dialog>
        
        <Dialog open={deleteBusiness !== 0}>
          <DialogTitle>Are you sure you want delete business?</DialogTitle>
          <DialogContent>It will delete all data related to business permanently</DialogContent>
          <DialogActions>
            <Button onClick={()=>setDeleteBusiness(0)}>cancel</Button>
            <Button onClick={
              deleteBusinessFunc
            } variant="contained" color="error">delete</Button>
          </DialogActions>
        </Dialog>

      <div className="ag-theme-alpine" style={{ height: '600px', width: '100%', padding: '16px' }}>
        <AgGridReact
          rowData={selector?.data || []}
          columnDefs={useMemo(() => [
            {
              field: 'business_id',
              headerName: 'Id',
              width: 100,
              cellRenderer: (params) => (
                <Link to={"/admin/business/" + params.value} style={{ color: '#1976d2' }}>
                  {params.value}
                </Link>
              )
            },
            {
              field: 'name',
              headerName: 'Name',
              flex: 1,
              minWidth: 150
            },
            {
              field: 'credit',
              headerName: 'Credit',
              width: 120,
              valueFormatter: (params) => `₹${parseFloat(params.value || 0).toFixed(2)}`
            },
            {
              field: 'purchase_date',
              headerName: 'Last Purchase Date',
              width: 180,
              valueFormatter: (params) => moment(params.value).format("DD-MM-YYYY")
            },
            {
              field: 'expired_plan',
              headerName: 'Expiry',
              width: 150,
              valueFormatter: (params) => moment(params.value).format("DD-MM-YYYY")
            },
            {
              field: 'restrict',
              headerName: 'Restrict',
              width: 120,
              cellRenderer: (params) => {
                return (
                  <Box display={'flex'} alignItems={'center'}>
                    <Switch 
                      size="small"
                      onChange={(ev, check) => {
                        restrictBusiness(
                          dispatch,
                          params.data?.business_id,
                          params.data?.restrict === 0 ? 1 : 0
                        );
                      }} 
                      checked={params.data?.restrict === 1}
                    />
                  </Box>
                );
              },
              sortable: false,
              filter: false
            },
            {
              field: 'plan',
              headerName: 'Plan',
              width: 250,
              cellRenderer: (params) => {
                const e = params.data;
                return (
                  <Box display={'flex'} alignItems={'center'} gap={2} flexDirection={'column'}>
                    <select
                      className="border px-2 py-1 rounded-md"
                      name={`date-${e?.business_id}`}
                      id={`date-${e?.business_id}`}
                      value={e?.subscription}
                      onChange={(ev) => {
                        dispatch(changeBusinessPlan({
                          id: e?.business_id,
                          plan: parseInt(ev.target.value),
                          price: selectorPlan.plansPrices.filter(ele => ele.subscription === parseInt(ev.target.value))[0]?.id
                        }));
                      }}
                    >
                      <option value={0}>Select Plan</option>
                      {
                        selectorPlan?.plans?.map(
                          (plan, i) => <option key={i} value={plan.id}>{plan.name}</option>
                        )
                      }
                    </select>
                    <select
                      className="border px-2 py-1 rounded-md"
                      name={`date-${e?.business_id}`}
                      id={`date-${e?.business_id}`}
                      value={e?.subscription_month}
                      onChange={(ev) => {
                        dispatch(changeBusinessPrice({ id: e?.business_id, price: parseInt(ev.target.value) }));
                      }}
                    >
                      <option value={0}>Select Month</option>
                      {
                        selectorPlan.plansPrices?.filter(ele => ele.subscription === e.subscription).map(
                          (price, i) => <option key={i} value={price.id}>{price.month} Months - ₹{price.price}</option>
                        )
                      }
                    </select>
                  </Box>
                );
              },
              sortable: false,
              filter: false
            },
            {
              field: 'actions',
              headerName: 'Action',
              width: 150,
              cellRenderer: (params) => {
                const e = params.data;
                return (
                  <Box display={'flex'} alignItems={'center'}>
                    <Button size="small" onClick={() => renewLocal(e?.business_id, e?.subscription, e?.subscription_month, 0)}>
                      Save
                    </Button>
                    <IconButton size="small" onClick={() => { setDeleteBusiness(e?.business_id); }}>
                      <MdDelete />
                    </IconButton>
                  </Box>
                );
              },
              sortable: false,
              filter: false
            }
          ], [selectorPlan, dispatch])}
          defaultColDef={useMemo(() => ({
            sortable: true,
            filter: true,
            resizable: true
          }), [])}
          pagination={true}
          paginationPageSize={10}
          animateRows={true}
        />
      </div>
      </div>
    </AppLayout>
  );
};

export default BusinessList;


{/* <div className="table-wrapper">
<div className="table-container">
<div className="td-head">
  <p className=" td-element">Id</p>
  <p className=" td-element">Business Name</p>
  <p className=" td-element">Credit</p>
  <p className=" td-element">Last Purchase Date</p>
  <p className=" td-element">Expiry Date</p>
  <p className=" td-element">Restricted</p>
  <p className=" td-element">Restrict</p>
  <p className=" td-element">Plan</p>
  <p className=" td-element">Actions</p>
</div>
<div className="flex-1">
  {
    selector?.data?.map((e, i) => (
      <div
        className="td-row"
        key={i}
      >
        <p className="td-element highlited">
          <Link to={"/admin/business/" + e?.business_id}>
            {e?.business_id}
          </Link>
        </p>
        <p className=" td-element">{e?.name}</p>
        <p className=" td-element">₹{parseFloat(e?.credit).toFixed(2)}</p>
        <p className=" td-element">
          {moment(e?.purchase_date).format("DD-MM-YYYY")}
        </p>
        <p className=" td-element">
          {moment(e?.expired_plan).format("DD-MM-YYYY")}
        </p>

        <p className=" td-element">
          {e?.restrict === 0 ? "No" : "Yes"}
        </p>
        <p className=" td-element flex flex-col items-center gap-4 p-4">
          <button
            onClick={() => {
              restrictBusiness(
                dispatch,
                e?.business_id,
                e?.restrict === 0 ? 1 : 0
              );
            }}
          >
            {e?.restrict === 0 ? "Restrict" : "Unrestrict"}{" "}
          </button>
        </p>
        <p className=" td-element flex flex-col items-center gap-4 p-4">
           <select
              className="border px-2 py-1 rounded-md border-blue-800 text-blue-800"
              name={`date-${e?.business_id}`}
              id={`date-${e?.business_id}`}
              value={e?.subscription}
              onChange={(ev) =>{
                console.log(selectorPlan.plansPrices,ev.target.value);
                  dispatch(changeBusinessPlan({id:e?.business_id,plan:parseInt(ev.target.value),price: selectorPlan.plansPrices.filter(ele=>ele.subscription === parseInt(ev.target.value))[0].id}))
              }
              }
            >
              <option value={0}>Select Plan</option>
              {
                selectorPlan?.plans?.map(
                  (plan,i)=><option value={plan.id}>{plan.name}</option>
                )
              }
            </select>
            <select
              className="border px-2 py-1 rounded-md border-blue-800 text-blue-800"
              name={`date-${e?.business_id}`}
              id={`date-${e?.business_id}`}
              value={e?.subscription_month}
              onChange={(ev) =>{
                dispatch(changeBusinessPrice({id:e?.business_id,price:parseInt(ev.target.value)}))
              }
              }
            >
              {
                selectorPlan.plansPrices?.filter(ele=>ele.subscription === e.subscription).map(
                  (price,i)=><option value={price.id}>{price.month} Months - ₹{price.price}</option>
                )
              }
            </select>
        </p>

        <p className=" td-element flex justify-center items-center gap-2">
         <p onClick={()=>renewLocal(e?.business_id,e?.subscription,e?.subscription_month,0)} className="highlited">Save</p>
          <MdDelete color="red" className="cursor-pointer" onClick={()=>setDeleteBusiness(e?.business_id)}/>
        </p>
      </div>
    ))
  }
</div>
</div>
</div> */}